<i18n>
    [
        "product__fitGuidance--sizeRecommender",
        "product__fitGuidance--sizeRecommenderTwoSize",
        "product__fitGuidance--sizeRecommenderThreeOrMore",
    ]
</i18n>

<template>
    <BaseMarkdown v-if="showLabel" :source="label" class="o-text--caption" />
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import { getRecommendedSizes } from '~routes/product/js/product-utils';
import BaseMarkdown from '~coreModules/core/components/ui/BaseMarkdown.vue';

const props = defineProps({
    fitGuidance: {
        type: Object,
        required: true,
    },
});

const { t } = useI18n();

const recommendedSizes = computed(() => getRecommendedSizes(props.fitGuidance?.fitReviews));

const showLabel = computed(() => recommendedSizes.value.length > 0);

const label = computed(() => {
    if (recommendedSizes.value.length === 1) {
        return t('product__fitGuidance--sizeRecommender', [recommendedSizes.value[0]]);
    }
    if (recommendedSizes.value.length === 2) {
        return t('product__fitGuidance--sizeRecommenderTwo', [...recommendedSizes.value]);
    }

    return t('product__fitGuidance--sizeRecommenderThreeOrMore');
});
</script>
